import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { ClientCreateRequest } from '~client/model/admin/client-create-request';
import { ClientProfileResponse } from '~client/model/client-profile-response';

/* Admin APIs to create/get Clients */
export class AdminClientController extends BaseController {
  /* Allows the admin to create a client */
  public createClient$(request: ClientCreateRequest): Observable<ClientProfileResponse> {
    return this.post$('/admin/client', request);
  }

  /* Allows the admin to get the list of all clients */
  public getClientList$(): Observable<ClientProfileResponse[]> {
    return this.get$('/admin/client/list');
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/controller/admin-client-controller.ts